import { render, staticRenderFns } from "./TwoFactorForm.vue?vue&type=template&id=4aa6807f&"
import script from "./TwoFactorForm.vue?vue&type=script&lang=js&"
export * from "./TwoFactorForm.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorForm.vue?vue&type=style&index=0&id=4aa6807f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports